/*
 * Copyright (c) 2023. American Express Company
 */

import styles from './AccountNickname.module.scss';
import { ButtonSecondary, ButtonTertiary } from '@americanexpress/dls-react';
import LiteralsService from 'src/services/literals/LiteralsService';
import React from 'react';
import { DLSSize } from 'src/types/dls-size.enum';
import { NicknameEditBoxViewModel } from 'src/types/view-models/nickname-edit-box.view.model';
import { Form, Formik } from 'formik';
import BasicInput from 'src/components/formik-fields/basic-input/BasicInput';
import Selectors from 'src/utils/selectors';

export default function NicknameEditBox({
    label,
    nickname,
    handleSave,
    handleSecondaryButtonClick,
    secondaryButtonLabel,
    placeholder,
    className
}: NicknameEditBoxViewModel): JSX.Element {
    return (
        <div className={`${className} ${styles.nicknameBox}`} data-cy={Selectors.SpendSmart.NICKNAME_EDIT}>
            <Formik
                initialValues={{ name: nickname }}
                onSubmit={async (values, actions) => {
                    await handleSave(values);
                    actions.resetForm({ values });
                }}
            >
                {({ dirty, isSubmitting }) => (
                    <Form className={styles.nicknameForm}>
                        <BasicInput id="name" label={label} placeholder={placeholder} />
                        <div className={styles.nicknameButtonContainer}>
                            <ButtonSecondary
                                data-cy={Selectors.SpendSmart.SAVE_NICKNAME_BUTTON}
                                size={DLSSize.SMALL}
                                type="submit"
                                disabled={!dirty}
                                loading={isSubmitting}
                                className={styles.nicknameButton}
                            >
                                {LiteralsService.getLiteral('CommonText.save')}
                            </ButtonSecondary>
                            <ButtonTertiary
                                data-cy={Selectors.SpendSmart.DELETE_NICKNAME_BUTTON}
                                size={DLSSize.SMALL}
                                onClick={handleSecondaryButtonClick}
                                className={styles.nicknameButton}
                            >
                                {secondaryButtonLabel}
                            </ButtonTertiary>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
